module.exports = __webpack_public_path__ + "static/media/Message-icon.7a269813.svg";